import React from 'react'
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker'
import { Dayjs } from 'dayjs'

import { lightTheme } from '~createTheme'

interface CustomDateTimePickerProps<TDate extends Dayjs = Dayjs>
  extends Omit<DateTimePickerProps<TDate>, 'open' | 'onOpen' | 'onClose'> {}

const CustomDateTimePicker: React.FC<CustomDateTimePickerProps> = (props) => {
  const [open, setOpen] = React.useState(false)

  const handleClose = (): void => {
    const activeElement = document.activeElement
    const isInputElement = activeElement?.tagName === 'INPUT'

    if (!isInputElement) {
      setOpen(false)
    }
  }

  const placeHolder = props.disabled ? { placeholder: '' } : {}

  return (
    <DateTimePicker
      {...props}
      open={open}
      onClose={handleClose}
      slotProps={{
        ...props.slotProps,
        textField: {
          ...props.slotProps?.textField,
          onClick: () => {
            if (!props.disabled) setOpen(!open)
          },
          ...placeHolder,
          sx: {
            backgroundColor: props.disabled ? lightTheme.palette.action.disabledInput : 'white',
            '& .MuiInputBase-root': {
              cursor: 'pointer',
            },
            '& .MuiInputBase-input': {
              cursor: 'text',
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: 'black',
            },
            '& .MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
              borderColor: lightTheme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: '2px solid #ffffff',
              outline: '2px solid #0894cf',
              outlineOffset: '2px',
              boxShadow: '0 0 0 2px #98e0ff, 0 0 0 4px #98e0ff',
            },
          },
        },
        openPickerButton: {
          ...props.slotProps?.openPickerButton,
          onClick: () => {
            if (!props.disabled) setOpen(!open)
          },
        },
        popper: {
          ...props.slotProps?.popper,
          sx: {
            zIndex: 1300,
          },
        },
      }}
    />
  )
}

export default CustomDateTimePicker
